import React from 'react';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';

import Unit from './unit';

const Container = styled.div`
  background: #DEDEDE;
  padding: 46px 0;
  .units {
    display: flex;
    flex-wrap: wrap;
  }
  .content {
    font: italic bold 20px 'Times new roman';
    text-align: center;
    img {
      display: block;
      margin: 40px auto 0;
      max-width: 100%;
    }
  }
`

const Unidades = ({items, texto, mapa, link}) => {
  return (
    <Container id={ link }>
      <div className="wrapper">
        <div className="units">
          {
            items.map((item, index) => {
              return (
                <Unit {...item} key={ index }/>
              )
            })
          }
        </div>
        <div className="content">
          { RichText.render(texto) }
          <img alt={ texto[0].text } src={ mapa.url } />
        </div>
      </div>
    </Container>
  )
}

export default Unidades;
